import { render } from "./AdminEmployees.vue?vue&type=template&id=41d5396e&scoped=true"
import script from "./AdminEmployees.vue?vue&type=script&lang=js"
export * from "./AdminEmployees.vue?vue&type=script&lang=js"

import "./AdminEmployees.vue?vue&type=style&index=0&id=41d5396e&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d5396e"]])

export default __exports__